import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  paper: {
    // paddingTop: theme.spacing(),
    // padding: theme.spacing(3),
    minWidth: '60%',
    maxWidth: '822px',
    maxHeight: '90%',
    overflowY: 'auto',
  },
  topBar: {
    backgroundColor: '#F6F6F6',
    padding: '20px 24px',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '133.4%',
    color: '#000000',
  },
  text: {
    width: '100%',
    margin: '10px 0',
    backgroundColor: theme.palette.background.paper,
    fontSize: 15,
    color: 'black',
  },
  subtext: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    fontSize: 12,
    color: 'grey',
  },
  textPrice: {
    width: '100%',
    marginLeft: 32,
    backgroundColor: theme.palette.background.paper,
    fontSize: 15,
    fontWeight: 600,
    color: 'black',
  },
  input: {
    minWidth: 250,
    flexGrow: 1,
    fontSize: 16,
    color: 'rgb(0 0 0 / 87%)',
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'rgb(0 0 0 / 87%)',
    },
  },
  row: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(2),
    flexBasis: '45%',
    flexWrap: 'wrap',
    '@media (max-width: 1399px)': {
      flexBasis: '100%',
    },
  },
  block: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  container: {},
  flexBetween: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  flexBox: {
    display: 'flex',
    width: '100%',
  },
  flexCenter: {
    display: 'flex',
    width: '100%',
    marginTop: '30px',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  flex: {
    display: 'flex',
    width: '100%',
    marginBottom: '30px',
  },
  flexEnd: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    marginBottom: '20px',
  },
  box: {
    padding: '24px',
  },
  content: {
    width: 'calc(100% - 30px)',
  },
  checkIcon: {
    color: 'green',
    marginRight: 2,
  },
  rightBox: {
    width: '60%',
    padding: '24px',
    backgroundColor: '#f4f4f6',
  },
  card: {
    width: '100%',
    padding: '24px',
    backgroundColor: 'white',
  },
  icon: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    backgroundColor: '#007DFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    marginRight: '15px',
  },
  profileContainer: {
    marginRight: 32,
    width: 192,
  },
  profileImgContainer: {
    marginRight: 10,
  },
  profileImg: {
    width: 200,
    borderRadius: '50%',
  },
  formContainer: {
    marginRight: 32,
    flex: 1,
  },
  heading: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 25,
  },
  closeIcon: {
    padding: 0,
    minWidth: 'auto',
  },
  list:{
    listStyleType: 'square',
    margin: '10px',
    padding: '10px',
  },
  listItem:{
    listStyleType: 'square',
    padding: '5px',
  },
  cancelButton: {
    backgroundColor: 'white',
  }
}));
